// MultipleChoice.tsx
import React from "react";
import Twemoji from "react-twemoji";
import "./styles/MultipleChoice.scss";

interface MultipleChoiceProps {
  id: string;
  text: string;
  emoji: string;
  statement: string;
  answers: string[];
  value: number | null;
  onChange: (value: number | null) => void;
}

const MultipleChoice: React.FC<MultipleChoiceProps> = ({
  id,
  text,
  emoji,
  statement,
  answers,
  value,
  onChange,
}) => {
  const isSet = value != null;

  const handleSelect = (index: number) => {
    if (value === index) {
      onChange(null);
    } else {
      onChange(index);
    }
  };

  const handleClear = () => {
    onChange(null);
  };

  return (
    <div className="multiple-choice">
      <div className="multiple-choice__header">
        <Twemoji options={{ className: "twemoji" }}>
          <span className="multiple-choice__emoji">{emoji}</span>
        </Twemoji>
        <div className="multiple-choice__question">{text}</div>
      </div>

      <div className="multiple-choice__options">
        {answers.map((answer, index) => (
          <button
            key={`${id}-${index}`}
            className={`multiple-choice__option ${
              value === index ? "multiple-choice__option--selected" : ""
            }`}
            onClick={() => handleSelect(index)}
          >
            {answer}
          </button>
        ))}
      </div>

      {/* {isSet && (
        <button className="multiple-choice__clear" onClick={handleClear}>
          Clear selection
        </button>
      )} */}
    </div>
  );
};

export default MultipleChoice;
